import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostContent,
	PostContentModel,
	PostContentParams,
} from 'domain/usecases/private/content/post-content';

export class RemotePostContent implements PostContent {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostContentModel>,
	) {}

	async post({signal, ...params}: PostContentParams): Promise<PostContentModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
